export default "__VITE_PUBLIC_ASSET__af8e3f45__"